module.exports = __webpack_public_path__ + "img/info_white.b9c93f7b.svg";